import { useHistory } from 'react-router';
import { TrainingState, useTrainingStore } from './state';
import { useTrainingUrl } from './useTrainingUrl';
import { isIOS, isIOS13, isIPad13, isIPhone13 } from 'react-device-detect';

const selector = (state: TrainingState) => state.next;

export function useNextSequence() {
  const url = useTrainingUrl();
  const history = useHistory();
  const next = useTrainingStore(selector);

  return async () => {
    const id = await next();

    if (isIOS || isIOS13 || isIPad13 || isIPhone13) {
      window.location.href = `${url}/${id}`;
    } else {
      history.push(`${url}/${id}`);
    }
  };
}
